export const LOAD_STATE = 'LOAD_STATE';
export const SET_LOADING = 'SET_LOADING';
export const UPDATE_ORGANIZATION = 'UPDATE_ORGANIZATION';
export const UPDATE_AUTO_INVOICING = 'UPDATE_AUTO_INVOICING';
export const SET_LOGO_PARAMS = 'SET_LOGO_PARAMS';
